module.exports = __webpack_public_path__ + "img/mew-custom-token-form.a304e254.png";